import GenericPatientDetailsList from "../components/GenericPatientDetailsList";

const PatientArrivalsPatientsList = () => {
  return (
    <GenericPatientDetailsList
      header="Patient Arrivals"
      screen="patient_arrivals"
      iconUrl="/patient_arrivals"
    />
  );
};

export default PatientArrivalsPatientsList;
